import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../store';
import { actions } from '../store/actions';
import { DishType } from '../types';

export const useCartHandler = () => {
  const dispatch = useDispatch();
  const cart = useSelector((state: RootState) => state.cartSlice);

  const addToCart = (
    dish: DishType,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    dispatch(actions.addToCart(dish));
  };

  const removeFromCart = (
    dish: DishType,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    dispatch(actions.removeFromCart(dish));
  };

  const getDishQty = (id: number, isFullPrice: boolean = true): number => {
    const dishInCart = cart.list.find(
      (dish) => dish.id === id && dish.isFullPrice === isFullPrice
    );
    return dishInCart ? dishInCart.quantity ?? 0 : 0;
  };

  return {
    addToCart,
    removeFromCart,
    getDishQty,
  };
};
